export class PlanGoodsDetailModel {
  /**
   * Ｐコード共通
   */
  // 受注コード
  public orderCode: string = <string>'';

  // Ｐコード
  public pCode: string = <string>'';

  /**
   * アイテムコード共通
   */
  // アイテムコード
  public itemCode: string = <string>'';

  // ＪＡＮコード
  public jANCode: string = <string>'';

  // JANコード識別フラグ
  public janCodeDiv: string = <string>'';

  /**
   * アイテムコード基本
   */
  // ＦＣ・ＭＣ手数料
  public fCMCFee: string = <string>'';

  // 特殊発注区分
  public specialOrderType: string = <string>'';

  // 在庫繰越区分
  public stockType: string = <string>'';

  // 分納指定回数
  public installmentTimes: string = <string>'';

  // 物流滞留日数
  public pDPilingUpDays: string = <string>'';

  // 発注単位区分
  public orderUnitType: string = <string>'';

  // 価格区分
  public priceType: string = <string>'';

  // メーカー希望小売価格(参考)
  public makerPrice: string = <string>'';

  // 発注先取引先コード
  public orderClientCode: string = <string>'';

  // 支払先取引先コード
  public payeeClientCode: string = <string>'';

  // 価格バンドル
  public bundlePrice: string = <string>'';

  // 確定入数
  public fixContainNum: string = <string>'';

  // 組数
  public setQuantity: string = <string>'';

  /**
   * アイテムコード仕様書１
   */
  // メーカー名称
  public makerName: string = <string>'';

  // メーカー名掲載表示区分
  public makerNamePublishType: string = <string>'';

  // ピースサイズ（縦）
  public peaceSizeLength: string = <string>'';

  // ピースサイズ（横）
  public peaceSizeWidth: string = <string>'';

  // ピースサイズ（高）
  public peaceSizeHight: string = <string>'';

  // ピース重量
  public peaceWeight: string = <string>'';

  // ケースサイズ（縦）
  public caseSizeLength: string = <string>'';

  // ケースサイズ（横）
  public caseSizeWidth: string = <string>'';

  // ケースサイズ（高）
  public caseSizeHight: string = <string>'';

  // ケース重量
  public caseWeight: string = <string>'';

  // 遺伝子組換表示区分
  public geneRecombinationDiv: string = <string>'';

  /**
   * アイテムコード仕様書２
   */
  // 分析単位
  public analysisUnit: string = <string>'';

  // 熱量(Kcal)
  public calorie: string = <string>'';

  // たんぱく質(g)
  public protein: string = <string>'';

  // 脂質(g)
  public lipid: string = <string>'';

  // 炭水化物(g)
  public carbohydrate: string = <string>'';

  // ナトリウム(mg)
  public sodium: string = <string>'';

  // アレルゲン調査対象区分
  public allergenTargetType: string = <string>'';

}
